import { makeStyles, Theme } from '@material-ui/core';

type StylesProps = {
  tableItemGridTemplate: string;
  rowIsClickable: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  item: ({ tableItemGridTemplate, rowIsClickable }: StylesProps) => ({
    display: 'grid',
    gridTemplateColumns: tableItemGridTemplate,
    paddingLeft: theme.spacing(0),
    borderBottom: `1px solid ${theme.palette.gray[300]}`,
    cursor: rowIsClickable ? 'pointer' : 'auto',
    padding: theme.spacing(1.25, 0),
  }),
}));

export default useStyles;
